import React from 'react'

import { useTheme } from 'styled-components'

import CheckInfluencerIcon from 'src/Assets/Svg/pages-icons/CheckMark.svg?react'

import { MainWrapper, Circle, InnerWrapper, Divider, Text } from './styles'

interface StatusProps {
  step?: 1 | 2
}

const Status: React.FC<StatusProps> = ({ step }) => {
  const theme = useTheme()

  if (!step) {
    return null
  }

  return (
    <MainWrapper>
      <div>
        <InnerWrapper>
          <Circle status>{step === 1 ? 1 : <CheckInfluencerIcon />}</Circle>
          <Divider status />
        </InnerWrapper>

        <Text color={theme.color.brandGreen} align='left'>
          Connect your TikTok
        </Text>
      </div>

      <div>
        <InnerWrapper>
          <Divider status={step === 2} />
          <Circle status={step === 2}>2</Circle>
        </InnerWrapper>

        <Text
          color={step === 2 ? theme.color.brandGreen : theme.color.darkGrey}
          align='right'
        >
          Set your contact email
        </Text>
      </div>
    </MainWrapper>
  )
}

export default Status
